exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.announcement-highlight{position:relative;width:100%;height:100%}.announcement-highlight .mock-delay-button{height:40px;width:182px;margin:0;border:none;border-radius:4px;background-color:#d0021b;color:#fff;font-family:Open Sans,sans-serif;font-size:16px;font-weight:600;line-height:40px;text-align:center;margin-left:calc(50% - 89px);margin-top:42px}.announcement-highlight .highlight-img{margin-left:10px;margin-top:38px}.delays-announcement-circle-multiple{position:absolute;left:0;width:0;height:100%;width:100%;background-color:transparent}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/modals/CircleAnnouncement/DelaysAnnouncementCircleMultiple/DelaysAnnouncementCircleMultiple.scss
// module id = 1703
// module chunks = 0